import React from "react";
import ImageTiles from "../ImageTiles";
import { Container } from "./styles";
import { EnvironmentTypes, currentEnvironment } from "../../../environment";

const isProdEnv = [
  EnvironmentTypes.STAGING,
  EnvironmentTypes.PRODUCTION,
].includes(currentEnvironment);

const TestimonialsTiles = ({
  allStoryComposition = {},
  testimonialTiles = {},
}) => {
  const testimonialData = allStoryComposition?.edges?.reduce(
    (acc, { node: { searchImage, uri, title, devOnly } }) => {
      if (isProdEnv && devOnly) {
        return acc;
      }

      acc.push({
        label: title,
        image: searchImage,
        linkUrl: `/${uri}`,
      });

      return acc;
    },
    []
  );

  return (
    <Container>
      <ImageTiles
        sectionTitle={testimonialTiles?.props?.testimonialTitle}
        ImageTilesList={testimonialData}
      />
    </Container>
  );
};

export default TestimonialsTiles;
